var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 32,
    viewBox: "0 0 76 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 76,
    height: 29,
    rx: 3,
    fill: "#44546A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.928 10.608H39.936C41.2053 10.608 42.192 10.944 42.896 11.616C43.6107 12.2773 43.968 13.1787 43.968 14.32C43.968 15.4507 43.6107 16.352 42.896 17.024C42.192 17.6853 41.2053 18.016 39.936 18.016H37.088V22H34.928V10.608ZM37.088 16.16H39.84C40.4693 16.16 40.9493 16.0053 41.28 15.696C41.6213 15.376 41.792 14.9173 41.792 14.32C41.792 13.7227 41.6213 13.264 41.28 12.944C40.9493 12.624 40.4693 12.464 39.84 12.464H37.088V16.16ZM45.303 10.608H50.311C51.5803 10.608 52.567 10.944 53.271 11.616C53.9857 12.2773 54.343 13.1787 54.343 14.32C54.343 15.4507 53.9857 16.352 53.271 17.024C52.567 17.6853 51.5803 18.016 50.311 18.016H47.463V22H45.303V10.608ZM47.463 16.16H50.215C50.8443 16.16 51.3243 16.0053 51.655 15.696C51.9963 15.376 52.167 14.9173 52.167 14.32C52.167 13.7227 51.9963 13.264 51.655 12.944C51.3243 12.624 50.8443 12.464 50.215 12.464H47.463V16.16ZM54.5373 10.608H64.0093V12.544H60.3613V22H58.1853V12.544H54.5373V10.608Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20H18V15H13V20ZM13 13H25V8H13V13ZM20 20H25V15H20V20ZM13 22C12.45 22 11.9792 21.8042 11.5875 21.4125C11.1958 21.0208 11 20.55 11 20V8C11 7.45 11.1958 6.97917 11.5875 6.5875C11.9792 6.19583 12.45 6 13 6H25C25.55 6 26.0208 6.19583 26.4125 6.5875C26.8042 6.97917 27 7.45 27 8V20C27 20.55 26.8042 21.0208 26.4125 21.4125C26.0208 21.8042 25.55 22 25 22H13ZM9 26C8.45 26 7.97917 25.8042 7.5875 25.4125C7.19583 25.0208 7 24.55 7 24V10H9V24H23V26H9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.2a0ddb24ce0bebedb3da1afcc306938d.svg";
export { ForwardRef as ReactComponent };